import { provideSingleton, lazyInject } from './inversify';
import { ApiService } from './api_service';
import { TriggerService } from '../core/trigger/trigger_service';
import { SystemOptionsService } from './system_options_service';

@provideSingleton(StructureService) // Diese Zeile definiert die Klasse bzw. eine Instanz davon als Service
export class StructureService {

    constructor() {
        this.getStructure = this.getStructure.bind(this);
        this.translateType = this.translateType.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(TriggerService) private triggerService: TriggerService;
    @lazyInject(SystemOptionsService) private optionsService: SystemOptionsService;

    public static structures: any = {}; // StructureService.structures
    private structures: any = {};
    private modes: any = {};
    private structuresUser: any = {};
    private reloadStructuresReady: any = {};
    private debug = false;
    private override = 1;

    getStructureNames(modul: string, filter: boolean) {
        const structs = filter ? this.filterStructure(this.structures[modul], this.modes[modul]) : this.structures[modul];
        // console.log('CheckStruct: ', modul, this.structures);
        if (this.structures[modul]) {
            return Object.keys(structs).map((k) => {
                return {
                    key: k,
                    name: this.structures[modul][k].TITEL,
                    name2: this.structures[modul][k].TITEL + ' (' + modul + ')',
                    modul: modul
                };
            });
        }
    }

    getStructureNamesAllModules(filter: boolean) {
        const modulKeys = Object.keys(this.structures);
        modulKeys.sort();
        let moduleNames: any = [];
        modulKeys.forEach((modul) => {
            const names = this.getStructureNames(modul, filter);
            if (names) {
                names.sort((a, b) => {
                    const na = a.name.trim().toLowerCase();
                    const nb = b.name.trim().toLowerCase();
                    if (na > nb) {
                        return 1;
                    } else if (na < nb) {
                        return -1;
                    }
                    return 0;
                });
                moduleNames = moduleNames.concat(names);
            }
        });
        return moduleNames;
    }

    getStructureUserNames(modul: string) {
        if (this.structuresUser[modul]) {
            return Object.keys(this.structuresUser[modul]).map((k) => {
                return {
                    id: k,
                    name: this.structuresUser[modul][k].TITEL,
                    info: this.structuresUser[modul][k].INFO,
                    group: this.structuresUser[modul][k].GROUP
                };
            });
        }
    }
    getFieldInfo(modul: string, entity: string, key: string) {
        const struct = this.getStructureByKey(modul, entity);
        if (struct) {
            if (this.debug) {
                console.log(struct.ATTS);
            }
            const entityTitel = struct.TITEL;
            // console.log('CHECK ' + key + ' : ', struct, struct.ATTS.find);
            const attFound = struct.ATTS.find((s: any) => s.KEY === key);
            const fieldName = attFound ? attFound.NAME : key;
            return { entityTitel, fieldName };
        }
    }
    getStructureAllByModul(modul: string) {
        if (this.structures[modul]) {
            return this.structures[modul];
        }
    }
    getStructureByKey(modul: string, key: string, sort?: boolean) {
        if (this.structures[modul] && this.structures[modul][key]) {
            const structure = this.structures[modul][key];
            if (sort && typeof structure === 'object' && Array.isArray(structure.ATTS)) {
                structure.ATTS.sort((a: any, b: any) => {
                    const na = a.NAME.trim().toLowerCase();
                    const nb = b.NAME.trim().toLowerCase();
                    if (na > nb) {
                        return 1;
                    } else if (na < nb) {
                        return -1;
                    }
                    return 0;
                });
            }
            // console.log('STRUCT GET: ', key, structure);
            return structure;
        }
    }
    addStructureByKey(modul: string, key: string, struct: any) {
        if (!this.structures[modul][key]) {
            this.structures[modul][key] = struct;
        }
        // console.log('STRUCT ADD: ', key, struct);
    }


    getStructureAll(callModul: string, callback: (structure: any) => void) {
        this.apiService.call('getModules', { override: 1 }, (data: string, suc: boolean) => {
            let modules;
            try {
                modules = JSON.parse(data);
            } catch (e) {
                console.error(e, data);
            }
            if (Array.isArray(modules)) {
                const len = modules.length;
                let count = 0;
                modules.forEach((modul: string, idx: number) => {
                    this.getStructure(modul, () => {
                        count++;
                        if (count === len) {
                            callback(this.structures[callModul]);
                        }
                    }, null);
                });
            }
        });
    }

    getStructure(modul: string, callback: (structure: ReadonlyArray<any>) => void, filter: boolean) {
        if (this.structures[modul]) {
            const struct = this.structures[modul];
            if (!filter) {
                callback(struct);
            } else {
                const structFiltered = this.filterStructure(struct, this.modes[modul]);
                callback(structFiltered);
            }
            return;
        }
        this.apiService.call(
            'getStructure',
            {
                module: modul,
                override: 1
            },
            (data: string, suc: boolean) => {
                // console.log(data);
                const dataParsed = JSON.parse(data);
                const struct = dataParsed.entities;
                const modes = dataParsed.modes;
                this.preprocessStructure(modul, struct);
                this.structures[modul] = struct;
                StructureService.structures[modul] = struct;
                this.modes[modul] = modes;
                if (!filter) {
                    callback(struct);
                } else {
                    const structFiltered = this.filterStructure(struct, this.modes[modul]);
                    callback(structFiltered);
                }
            });
    }

    reloadStructures() {
        console.log('*****************************  RELOAD STRUCTURES ****************************** ');
        // alert('Reload Structs');
        const modulKeys = Object.keys(this.structures);
        console.log('structure_service reloadStructures modulKeys :', modulKeys);
        this.structures = {};
        this.modes = {};
        modulKeys.forEach(key => this.getStructure(
            key,
            (struct) => {
                this.reloadStructuresReady[key] = true;
                if (Object.keys(this.reloadStructuresReady).length === modulKeys.length) {
                    console.log('reloadStructures done', this.structures);
                    this.triggerService.fire('structure_reload', 'ALL');
                }
            },
            false
        ));
    }
    getFilterModes(modul: string) {
        return this.modes[modul];
    }
    addGlobalReferences(modul: string, struct: any) {
        const referenceList = this.optionsService.getOptions('GlobalReferences');
        if (!referenceList) {
            return struct;
        }
        // console.log('addGlobalRef: ', struct, referenceList);
        // alert('addGlobalRef: ' + modul);
        Object.keys(struct).forEach((key: string) => {
            if (!struct[key].ATTS) {
                console.log('Invalid Structure: ' + struct[key]);
                return;
            }
            struct[key].ATTS.forEach((att: any) => {
                const refFound = referenceList.find((ref: any) => {
                    return ref.modul_src === modul && ref.entity_src === key && ref.field_src === att.KEY;
                });
                if (refFound) {
                    // console.log('REF EXIST', refFound);
                    if (!att.OPTS) {    // Nur wenn es noch keine OPTS gibt
                        att.OPTS = {
                            ENTITY: refFound.entity_dst,
                            IDENTIFIER: refFound.field_dst,
                            INPUT: refFound.fiel_dst,
                            MODUL: refFound.modul_dst
                        };
                    }
                }
            });
        });
    }
    filterStructure(struct: any, modes: any) {
        const structFiltered: any = {};
        if (!modes || !modes.mode) {    // Wenn kein Mode --> nicht filtern
            return struct;
        }
        const baseMode = modes.mode;    // Basis-Modus, falls es nichts explizites für eine Entity gibt
        Object.keys(struct).forEach((key: string) => {
            if (struct[key].SRC.type && (struct[key].SRC.type === 'USER' || struct[key].SRC.type === 'AUSWERTUNG'
                || struct[key].SRC.type === 'LEGACY')) {
                structFiltered[key] = struct[key];
            } else
                if (!modes.entities || !modes.entities[key]) {  // Keine Entity-Spezifischen Angaben
                    if (baseMode === 'allow') {
                        structFiltered[key] = struct[key];
                    } else {
                        // NADA
                    }
                } else { // Es gibt spezifische Angaben
                    const entMode = modes.entities[key].mode;
                    if (entMode && entMode === 'allow') {
                        // Wer den Key anlegt und nichts eingibt --> deny ... also allow nur wenn explizit angegeben
                        structFiltered[key] = struct[key];
                    } else {
                        // NADA
                    }
                }
        });
        return structFiltered;
    }
    getStructureUser(modul: string, callback: (structure: ReadonlyArray<any>) => void) {
        /*
        if (this.structures[modul]) {
            callback(<ReadonlyArray<any>> this.structures[modul]);
            return;
        }
        */
        this.apiService.call('getStructureUser', { module: modul, override: 1 }, (data: string, suc: boolean) => {
            const struct = JSON.parse(data).entities;
            this.preprocessStructure(modul, struct);
            this.structuresUser[modul] = struct;
            callback(struct);
        });
    }
    saveEntityStructure(modul: string, entity: string, entityType: string, entityStructure: any, callback: (suc: boolean) => void) {
        const entityObj: any = {};
        entityObj[entity] = entityStructure;
        entityStructure = { 'entities': entityObj };
        const entityStructure_json = JSON.stringify(entityStructure);
        console.log('structureService saveEntityStructure : ', entityStructure);
        this.apiService.call(
            'saveEntityStructure',
            { module: modul, entity: entity, entityType: entityType, entityStructure: entityStructure_json, override: 1 },
            (data: string, suc: boolean) => {
                const response = JSON.parse(data);
                if (response['success']) {
                    this.apiService.call(
                        'initStructure',
                        { module: modul, override: 1 },
                        (respInitStructure: string, sucInitStructure: boolean) => {
                            // console.log('structure_service, call initStructure after saveEntityStructure, response :');
                            // console.log(respInitStructure);
                            callback(response['success']);
                        }
                    );
                } else {
                    callback(response['success']);
                }
            }
        );
    }
    delEntityStructure(modul: string, entity: string, callback: (suc: boolean) => void) {
        this.apiService.call(
            'delEntityStructure',
            { module: modul, entity: entity, override: 1 },
            (data: string, suc: boolean) => {
                const response = JSON.parse(data);
                callback(response['success']);
            }
        );
    }
    preprocessStructure(modul: string, struct: any) {
        if (!struct) {
            return;
        }
        const keys = Object.keys(struct);
        keys.forEach((key: string) => {
            if (struct[key].ATTS) {
                struct[key].ATTS.forEach((att: any) => {
                    if (att.OPTS && att.OPTS.ENTITY) {
                        if (struct[att.OPTS.ENTITY]) {
                            att.OPTS.ENTITY_NAME = struct[att.OPTS.ENTITY].TITEL;
                        } else {
                            if (this.debug) {
                                console.log('Struct-Preprocess: Missing Entity-Info: ' + att.OPTS.ENTITY);
                            }
                        }
                    }
                });
            }
        });
        this.addGlobalReferences(modul, struct);
    }

    translateType(type: string) {
        switch (type) {
            case 'INT':
                return 'Ganzzahl';
            case 'DOUBLE':
                return 'Dezimalzahl';
            case 'TEXT':
                return 'Text';
            case 'DATE':
                return 'Datum';
            case 'TIME':
                return 'Zeit';
            case 'DATETIME':
                return 'Datum/Zeit';
            case 'FILE':
                return 'Datei';
            default: {
                if (type && type.substring(0, 4) === 'CHAR') {
                    return 'Zeichenkette';
                }
            }
        }
    }

    getStructureRefEntity(entitySelected: string, vName: string, vKey: string) {
        // console.log(entitySelected, refValues);
        const refName = 'Katalog ' + vName;
        let refId = entitySelected + '_k_' + vKey; // _k_ für Katalog
        refId = this.checkLengthTableName(refId, true);
        const refStructure = {
            ATTS: [
                {
                    FILTER_MODE: 'volltext',
                    FORMAT: 'NONE',
                    HIDDEN: '0',
                    KEY: 'name',
                    NAME: 'Bezeichnung',
                    REQUIRED: 'KEY',
                    SUMMARY: 'NONE',
                    TYPE: 'CHAR191'
                }
            ],
            SRC: {
                id: refId,
                type: 'USER'
            },
            TITEL: refName
        };
        return refStructure;
    }

    checkLengthTableName(name: string, isKatalog?: boolean) {
        // MySQL erlaubz Tabel-Name mit max. 64 Zeichen
        // 64 - entity_ (7)
        if (name.length > 57) {
            const stamp = Math.floor(new Date().getTime() / 1000).toString();
            if (!isKatalog) {
                name = name.substr(0, 57 - stamp.length - 1) + '_' + stamp;
            } else {
                name = name.substr(0, 57 - stamp.length - 3) + '_k_' + stamp; // _k_ für Katalog
            }
        }
        console.log(name);
        return name;
    }
}
